// extracted by mini-css-extract-plugin
export var bodySections = "_45-8";
export var gray = "_45-7";
export var green = "_45-4";
export var iconContainer = "_45-9";
export var iconWidgetContainer = "_45-1";
export var phoneIcon = "_45-2";
export var red = "_45-5";
export var statusDot = "_45-3";
export var widgetContainer = "_45-0";
export var yellow = "_45-6";